import { useNavigate } from 'react-router-dom';
import { useAtom, atom } from 'jotai'
import { getUserInfo, updateUserInfoName, logout } from '../../api/api';
import { userInfoAtom } from '../../atom';
import { useLocation } from "react-router-dom";

const dataAtom = atom("");
const seiAtom = atom("");
const meiAtom = atom("");
const seiYomiAtom = atom("");
const meiYomiAtom = atom("");
const errMsgAtom = atom("");
const departmentNameAtom = atom("");
const telAtom = atom("");
const isPbAtom = atom(localStorage.getItem("isPB") === "true" ? true : false);


const style = {
    maxWidth: '70%'
}

function MainComponent({ handleLoading }) {

    document.title = "Web問い合わせシステム| ファーストコンタクトセンター";
    const navigate = useNavigate();
    const location = useLocation();

    if (!location.state) {
        logout();
        window.location.replace("/fcc_login");
    }

    const [, setData] = useAtom(dataAtom);
    const [sei, setSei] = useAtom(seiAtom);
    const [mei, setMei] = useAtom(meiAtom);
    const [seiYomi, setSeiYomi] = useAtom(seiYomiAtom);
    const [meiYomi, setMeiYomi] = useAtom(meiYomiAtom);
    const [, setUserInfo] = useAtom(userInfoAtom);
    const [errMsg, setErrMsg] = useAtom(errMsgAtom);
    const [departmentName, setDepartmentName] = useAtom(departmentNameAtom);
    const [tel, setTel] = useAtom(telAtom);
    const [isPb, setIsPb] = useAtom(isPbAtom);

    if (location.state.page === true) {

        try {
            handleLoading(true);
            getUserInfo().then((resp) => {
                setData(resp);
                setSei(resp.sei);
                setMei(resp.mei);
                setSeiYomi(resp.seiYomi);
                setMeiYomi(resp.meiYomi);
                setErrMsg("");
                setDepartmentName(resp.departmentName);
                setTel(resp.telNo);
                setIsPb(resp.isPB);
                handleLoading(false);
            });
            location.state.page = false;
        } catch (e) {
            return e;
        }

    }

    function initInput() {
        setSei("");
        setMei("");
        setSeiYomi("");
        setMeiYomi("");
        setErrMsg("");
        setDepartmentName("");
        setTel("");
    }

    const kanaValidation = (text) => {
        // Unicodeの30A0～30FFをカタカナとする
        const katakanaRegex = /^[゠-ヿ]+$/;
        return katakanaRegex.test(text);
    }

    function isHankakuKanaValidation(text) {
        var reg = new RegExp(/[ｦ-ﾟ]+/);
        return reg.test(text);
    }

    const telValidation = (text) => {
        const telRegex = /^[0-9/-]*$/;
        return telRegex.test(text);
    }

    const buttonNameUpdate = async () => {

        let newSei = sei.replace(/^\s+/g, '');
        let newMei = mei.replace(/^\s+/g, '');
        let newDepartmentName = departmentName.replace(/^\s+/g, '');
        let checkIsPb = isPb;;
        let ret;
        let errMsgArray = [];
        if (newSei === "") {
            errMsgArray[0] = "姓";
        }
        if (newMei === "") {
            errMsgArray[1] = "名";
        }
        if (seiYomi === "") {
            errMsgArray[2] = "フリガナ（姓）";
        }
        if (meiYomi === "") {
            errMsgArray[3] = "フリガナ（名）"
        }
        if (checkIsPb === true) {
            if (newDepartmentName === "") {
                errMsgArray[4] = "部署名"
            }
            if (tel === "") {
                errMsgArray[5] = "電話番号"
            }
        }
        if (errMsgArray.length !== 0) {
            let arrStr = errMsgArray.toString();
            let newStr = arrStr.replaceAll(",", " ");
            setErrMsg(`${newStr}を設定してください。`);
            return;
        }
        if (errMsgArray.length === 0) {
            setErrMsg("");
        }
        if (!isHankakuKanaValidation(sei) === false) {
            alert("姓は、半角カタカナの入力はできません。");
            return;
        }
        if (!isHankakuKanaValidation(mei) === false) {
            alert("名は、半角カタカナの入力はできません。");
            return;
        }
        if (kanaValidation(seiYomi) === false) {
            alert("フリガナ（姓）は、全角カタカナで入力してください。");
            return;
        }
        if (kanaValidation(meiYomi) === false) {
            alert("フリガナ（名）は、全角カタカナで入力してください。");
            return;
        }
        if (!isHankakuKanaValidation(departmentName) === false) {
            alert("部署名は、半角カタカナの入力はできません。");
            return;
        }
        if (telValidation(tel) === false) {
            alert("電話番号の形が間違っています。");
            return;
        }
        handleLoading(true);
        ret = true;
        if (checkIsPb === true) {
            ret = await updateUserInfoName(
                sei.trim(),
                mei.trim(),
                seiYomi.trim(),
                meiYomi.trim(),
                departmentName ? departmentName.trim() : departmentName,
                tel.trim());
        }
        if (ret === false) {
            setErrMsg("現在サーバーが込み合っているか、または、システムメンテナンス中です。時間を置いて再試行してください。");
            handleLoading(false);
            return;
        }
        const userInfo = await getUserInfo();
        if (userInfo === false) {
            setErrMsg("現在サーバーが込み合っているか、または、システムメンテナンス中です。時間を置いて再試行してください。");
            handleLoading(false);
            return;
        }
        handleLoading(false);
        const userInforStorage = {
            sei: userInfo.sei.trim(),
            mei: userInfo.mei.trim(),
            seiYomi: userInfo.seiYomi.trim(),
            meiYomi: userInfo.meiYomi.trim(),
            departmentName: userInfo.departmentName.trim(),
            telNo: userInfo.telNo.trim()
        }
        localStorage.setItem("userInfoStorage", JSON.stringify(userInforStorage));
        const userName = `${userInfo.sei} ${userInfo.mei}`;
        const user = {
            userId: userInfo.userId,
            userName: userName,
        };
        setUserInfo(user);
        initInput();
        navigate("/inquiry_status", { state: { pageSubmit: false } });
    };
    return (
        <div>
            <div className="header-utility">
                <div className="header-utility-inner">
                    <ul className="header-utility-list sub">
                    </ul>
                </div>
            </div>
            <main className="site-main">
                <section className="sct-primary">
                    <div className="mod-hdg-l1">
                        <div className="inner">
                            <h1 className="hdg">Web問い合わせシステム</h1>
                            <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                        </div>
                    </div>
                    <div className="str-outer">
                        <div className="str-inner">
                            <h4 className="mod-hdg-l2-02">
                                <span>ユーザ情報初回登録</span>
                            </h4>
                            <div className="mod-list-02 of-notice">
                                <ul className="list">
                                    <li>
                                        <span className="mark"><em>※</em></span>
                                        <div className="content">
                                            <div className="mod-txt">
                                                <p><em><b>
                                                    利用者情報はPartner's BridgeまたはDWPより提供された情報を用いてログイン時に自動更新します。<br />
                                                    提供された情報が空値である場合のみ、利用者情報が更新されないため、当画面から修正して下さい。<br />
                                                </b></em></p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="mod-tbl-form mb-30">
                                <div>{errMsg}</div>
                                <table>
                                    <colgroup>
                                        <col className="w-20" />
                                        <col className="w-40" />
                                        <col />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">姓</span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="mod-input">
                                                    <input type="text" value={sei} onChange={(e) => setSei(e.target.value)} maxLength="10" id="sei" name="sei" style={style} />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">名</span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="mod-input">
                                                    <input type="text" value={mei} onChange={(e) => setMei(e.target.value)} maxLength="10" id="mei" name="mei" style={style} />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">フリガナ（姓）</span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="mod-input">
                                                    <input value={seiYomi} onChange={(e) => setSeiYomi(e.target.value)} type="text" maxLength="10" id="seiyomi" name="seiyomi" style={style} />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">フリガナ（名）</span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="mod-input">
                                                    <input value={meiYomi} onChange={(e) => setMeiYomi(e.target.value)} type="text" maxLength="10" id="meiyomi" name="meiyomi" style={style} />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    {isPb === true ?
                                        <>
                                            <tbody>
                                                <tr>
                                                    <td className="caption">
                                                        <div className="inner">
                                                            <b><span htmlFor="section">部署名</span></b>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="mod-input">
                                                            <input value={departmentName} onChange={(e) => setDepartmentName(e.target.value)} type="text" maxLength="128" id="syozoku" name="syozoku" style={style} />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody>
                                                <tr>
                                                    <td className="caption">
                                                        <div className="inner">
                                                            <b><span htmlFor="section">電話番号</span></b>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="mod-input">
                                                            <input value={tel} onChange={(e) => setTel(e.target.value)} type="text" maxLength="20" id="tel" name="tel" style={style} />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </>
                                        : null}
                                </table>
                            </div>
                            <div className="mod-btn of-no-arrow">
                                <div className="btn">
                                    <button onClick={buttonNameUpdate}>設定する</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}


export default MainComponent;